import React from "react";
import { Modal } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import validator from "validator";
import cookie from "react-cookies";

import { login, checkPhone, checkEmail, doActionAfterOptSuccess } from "../../model/profile";

import { commonErr } from "../common/errors";

import { LoadingInline } from "../common/loading";
import { otpAction, otpMethod } from "../common/common";

import { CustomInputLabelOutside, CustomSelect } from "../components/input";

import Login3rd from "../login/login3rd";

import ResetPwByEmail from "../account/resetpwbyemail";
import VerifyPhoneOpt from "../account/verifyphoneopt";
import VerifyPhoneOptBreak from "../account/verifyphoneoptbreak";

import { IcCloseRed, IcPassword, IcEye } from "../common/svg";

export class ResetPwForm extends React.Component {
	constructor() {
		super();
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			ip_reset_pw: "",
			ip_reset_pw_confirm: "",
		};
	}

	handleInputChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value,
		});
	};

	onResetPwBtnClick = () => {
		const { resetPwPhone, verifyToken, actionToken, otp } = this.props.otpData;

		if (
			!this.state.ip_reset_pw ||
			!this.state.ip_reset_pw_confirm ||
			this.state.ip_reset_pw === "" ||
			this.state.ip_reset_pw_confirm === ""
		) {
			this.setState({
				err: commonErr.FAIL,
				errMsg: "Mật khẩu không hợp lệ.",
			});
		} else if (this.state.ip_reset_pw !== this.state.ip_reset_pw_confirm) {
			this.setState({
				err: commonErr.FAIL,
				errMsg: "Mật khẩu lặp lại không đúng.",
			});
		} else {
			doActionAfterOptSuccess(
				resetPwPhone,
				otpAction.TOA_RECOVER_PASSWORD,
				otpMethod.TOP_MIOTO,
				verifyToken,
				actionToken,
				otp,
				this.state.ip_reset_pw
			).then((resp) => {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
			});
		}
	};

	onFinishButtonClick = () => {
		this.props.hideModal();
		this.props.hideForgotPasswordForm();
		this.props.showLoginModal();
	};

	render() {
		var content;
		if (this.state.err !== commonErr.SUCCESS) {
			content = (
				<div className="modal-input-body">
					{this.state.err < commonErr.SUCCESS && (
						<div className="textAlign-center text-danger">
							{this.state.errMsg}
							<div className="space m"></div>
						</div>
					)}
					<div className="line-form">
						<CustomInputLabelOutside
							type={"password"}
							name={"ip_reset_pw"}
							label={"Mật khẩu mới"}
							onChange={this.handleInputChange}
						/>
					</div>
					<div className="line-form">
						<CustomInputLabelOutside
							type={"password"}
							name={"ip_reset_pw_confirm"}
							label={"Nhập lại mật khẩu"}
							onChange={this.handleInputChange}
						/>
					</div>
					<div className="wrap-btn">
						<a className="btn btn-primary btn--s" onClick={this.onResetPwBtnClick}>
							Cập nhật mật khẩu
						</a>
					</div>
				</div>
			);
		} else {
			content = (
				<div className="modal-input-body">
					<div className="textAlign-center">Mật khẩu đã được làm mới thành công</div>
					<div className="wrap-btn">
						<a className="btn btn-primary btn--s" onClick={this.onFinishButtonClick}>
							Đăng nhập
						</a>
					</div>
				</div>
			);
		}
		return (
			<Modal show={this.props.show} onHide={this.props.hideModal} dialogClassName="modal-s modal-dialog modal-input">
				<Modal.Header closeButton={true} closeLabel={""}>
					<h5>Đặt lại mật khẩu</h5>
				</Modal.Header>
				<Modal.Body>{content}</Modal.Body>
			</Modal>
		);
	}
}

export class ForgotPasswordForm extends React.Component {
	constructor() {
		super();
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			phoneEmail: "",
			isPhone: true,
		};
	}

	handleKeyPress = (event) => {
		if (event.key === "Enter") {
			this.checkInput();
		}
	};

	onPhoneEmailChange = (event) => {
		const data = event.target.value;
		if (validator.isNumeric(data)) {
			this.setState({
				err: commonErr.INNIT,
				errMsg: "",
				phoneEmail: data,
				isPhone: true,
			});
		} else {
			this.setState({
				err: commonErr.INNIT,
				errMsg: "",
				phoneEmail: data,
				isPhone: false,
			});
		}
	};

	checkInput = () => {
		if (this.state.isPhone) {
			this.checkPhone();
		} else {
			this.checkEmail();
		}
	};

	checkPhone = () => {
		const data = this.state.phoneEmail;
		if (!validator.isNumeric(data)) {
			this.setState({
				err: commonErr.FAIL,
				errMsg: "Số điện thoại không hợp lệ.",
			});
		}

		this.setState({
			err: commonErr.LOADING,
			errMsg: "",
		});

		checkPhone(data).then((resp) => {
			if (!resp.data || !resp.data.data || resp.data.data.exist !== 1) {
				self.setState({
					err: commonErr.FAIL,
					errMsg:
						"Không tìm thấy tài khoản với số điện thoại bạn cung cấp. Vui lòng kiểm tra lại hoặc đăng kí tài khoản mới.",
				});
			} else {
				this.setState({
					err: commonErr.SUCCESS,
					errMsg: "",
				});
				this.props.hide();
				// self.accountKitElement.click();
				this.props.showVerifyPhoneOpt(data);
			}
		});
	};

	checkEmail = () => {
		const data = this.state.phoneEmail;

		if (!validator.isEmail(data)) {
			this.setState({
				err: commonErr.FAIL,
				errMsg: "Email không hợp lệ.",
			});
		} else {
			this.setState({
				err: commonErr.LOADING,
				errMsg: "",
			});

			checkEmail(data).then((resp) => {
				if (!resp.data || !resp.data.data || resp.data.data.exist !== 1) {
					this.setState({
						err: commonErr.FAIL,
						errMsg:
							"Không tìm thấy tài khoản với địa chỉ email bạn cung cấp. Vui lòng kiểm tra lại hoặc đăng kí tài khoản mới.",
					});
				} else {
					this.setState({
						err: commonErr.SUCCESS,
						errMsg: "",
					});
					this.props.hide();
					this.props.showVerifyEmail(data);
				}
			});
		}
	};

	render() {
		return (
			<Modal show={this.props.isShow} onHide={this.props.hide} dialogClassName="modal-s modal-input">
				<Modal.Header closeButton={true} closeLabel={""}>
					<h5>Quên mật khẩu</h5>
				</Modal.Header>
				<Modal.Body>
					<div className="modal-input-body">
						<div className="line-form">
							<CustomInputLabelOutside
								type={"text"}
								label="Điện thoại hoặc email"
								value={this.state.phoneEmail}
								onKeyPress={this.handleKeyPress}
								onChange={this.onPhoneEmailChange}
							/>
						</div>
						{this.state.err === commonErr.LOADING && <LoadingInline />}
						{this.state.err < commonErr.SUCCESS && (
							<div className="line-form">
								<p className="textAlign-center">{this.state.errMsg}</p>
							</div>
						)}
						<div className="wrap-btn">
							<a disabled={this.state.phoneEmail === ""} className="btn btn-primary btn--m" onClick={this.checkInput}>
								Tiếp tục
							</a>
						</div>
					</div>
				</Modal.Body>
			</Modal>
		);
	}
}

class Login extends React.Component {
	constructor(props) {
		super(props);
		cookie.save("_mcookietest", "_mcookietest", { path: "/" });
		const mcookietest = cookie.load("_mcookietest");
		cookie.remove("_mcookietest");
		this.state = {
			ip_username: "",
			ip_password: "",
			err: commonErr.INNIT,
			errMsg: "",

			resetPwPhone: "",
			resetAccessTok: "",
			showResetPwForm: false,
			isCookieAllowed: mcookietest !== undefined && mcookietest !== null && mcookietest !== "",
			inputType: "password",
		};
	}

	handleInputChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value,
		});
	};

	handleKeyPress = (event) => {
		if (event.key === "Enter") {
			this.onLoginBtnClick();
		}
	};

	onLoginBtnClick = (event) => {
		const username = this.state.ip_username;
		const password = this.state.ip_password;

		if (username !== "" && password !== "") {
			this.setState({ err: commonErr.LOADING });
			login(username, password).then((resp) => {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
				if (resp.data.error == -40212) {
					// required otp
					this.props.hideModal();
					this.showVerifyLoginPhoneOpt(username);
					return;
				}
				if (resp.data.error >= commonErr.SUCCESS) {
					this.props.getLoggedProfile();
					// this.props.hideModal();
					const pathname = cookie.load("_mpathdirect");
					if (pathname) {
						this.props.history.push(pathname);
						cookie.remove("_mpathdirect", { path: "/" });
						cookie.remove("_mpathOTP", { path: "/" });
					} else {
						window.location.reload();
					}
				}
			});
		}
	};

	showForgotPasswordForm = () => {
		this.setState({
			isShowForgotPasswordForm: true,
		});
		this.props.hideModal();
	};

	hideForgotPasswordForm = () => {
		this.setState({
			isShowForgotPasswordForm: false,
		});
	};

	showVerifyPhoneOpt = (phone) => {
		this.setState({
			forgotPasswordWithPhoneNumber: phone,
			showVerifyPhoneOpt: true,
		});
	};

	showVerifyLoginPhoneOpt = (phone) => {
		this.setState({
			forgotPasswordWithPhoneNumber: phone,
			showVerifyLoginPhoneOpt: true,
		});
	};

	hideVerifyLoginPhoneOpt = () => {
		this.setState({
			showVerifyLoginPhoneOpt: false,
		});
	};

	hideVerifyPhoneOpt = () => {
		this.setState({
			showVerifyPhoneOpt: false,
		});
	};

	showVerifyPhoneOptBreak = () => {
		this.setState({
			showVerifyPhoneOptBreak: true,
		});
	};

	hideVerifyPhoneOptBreak = () => {
		this.setState({
			showVerifyPhoneOptBreak: false,
		});
	};

	hideResetPwForm = () => {
		this.setState({
			showResetPwForm: false,
			resetPwPhone: "",
			resetAccessTok: "",
		});
	};

	onVerifyPhoneOptSuccess = (data) => {
		this.setState({
			showResetPwForm: true,
			otpData: data,
		});
	};

	showVerifyEmail = (email) => {
		this.setState({
			isShowVerifyEmail: true,
			isShowForgotPasswordForm: false,
			emailForReset: email,
		});
	};

	hideVerifyEmail = () => {
		this.setState({
			isShowVerifyEmail: false,
		});
	};

	onBackBtnClick = () => {
		this.setState({
			err: commonErr.INNIT,
			errMsg: "",
		});
	};

	toggleInput = () => {
		const { inputType } = this.state;
		this.setState({
			inputType: inputType === "password" ? "text" : "password",
			[`${name}`]: name === "password" ? "text" : "password",
		});
	};

	renderPw = () => {
		const { inputType } = this.state;

		return (
			<div className="wrap-svg" onClick={this.toggleInput}>
				{inputType === "password" ? <IcPassword /> : <IcEye />}
			</div>
		);
	};

	hideModal = () => {
		this.props.hideModal();
		this.setState({
			inputType: "password",
		});
	};

	render() {
		var content;
		const { inputType, isCookieAllowed, errMsg, err } = this.state;

		if (!isCookieAllowed) {
			content = (
				<div className="line-form">
					<p className="textAlign-center">
						Bạn cần cài đặt trình duyệt cho phép sử dụng cookies mới có thể đăng nhập hệ thống.
					</p>
				</div>
			);
		} else if (errMsg && errMsg !== "" && errMsg !== "Thành công") {
			content = (
				<div className="line-form">
					<p className="textAlign-center">{errMsg}</p>
					<div className="wrap-btn">
						<a className="btn btn-primary btn--m" name="backBtn" onClick={this.onBackBtnClick}>
							Thử lại
						</a>
					</div>
				</div>
			);
		} else {
			content = (
				<>
					<div className="line-form">
						<CustomInputLabelOutside
							type={"text"}
							name={"ip_username"}
							label="Số điện thoại hoặc email"
							onKeyPress={this.handleKeyPress}
							onChange={this.handleInputChange}
						/>
					</div>
					<div className="line-form">
						<CustomInputLabelOutside
							type={inputType}
							name={"ip_password"}
							label="Mật khẩu"
							onKeyPress={this.handleKeyPress}
							onChange={this.handleInputChange}
							icRight={this.renderPw()}
						/>
					</div>
					<div className="block-content textAlign-right">
						<a className="fontWeight-6 font-14" onClick={this.showForgotPasswordForm}>
							Quên mật khẩu?
						</a>
					</div>
					<div className="wrap-btn btn-register">
						<a className="btn btn--m btn-primary" onClick={this.onLoginBtnClick}>
							{err === commonErr.LOADING ? <LoadingInline /> : "Đăng nhập"}
						</a>
					</div>

					<p className="font-14 login-note">
						Bạn chưa là thành viên? <a onClick={() => this.props.openSignupForm()}>&nbsp;Đăng ký ngay</a>
					</p>

					{/* <a className="forgot-password" onClick={this.showForgotPasswordForm}>Quên mật khẩu?</a> */}
					{/* <a className="btn btn-primary btn--m" onClick={this.onLoginBtnClick}>Đăng nhập {this.state.err === commonErr.LOADING && <LoadingInline />}</a> */}
					{/* <p>Bạn chưa là thành viên? <a href="/signup">Hãy đăng kí ngay!</a></p><span className="line"></span> */}
					{/* <p className="textAlign-center">Hoặc đăng nhập bằng tài khoản</p> */}
					<Login3rd />
				</>
			);
		}
		return (
			<>
				<Modal show={this.props.show} onHide={this.hideModal} dialogClassName="modal-s modal-dialog modal-input">
					<Modal.Header closeButton={true} closeLabel={""}>
						<h5>Đăng nhập</h5>
					</Modal.Header>
					<Modal.Body>
						<div className="modal-input-body modal-login-body">{content}</div>
					</Modal.Body>
				</Modal>
				<ForgotPasswordForm
					isShow={this.state.isShowForgotPasswordForm}
					hide={this.hideForgotPasswordForm}
					showVerifyEmail={this.showVerifyEmail}
					showVerifyPhoneOpt={this.showVerifyPhoneOpt}
				/>
				{this.state.showVerifyPhoneOpt && (
					<VerifyPhoneOpt
						show={this.state.showVerifyPhoneOpt}
						hideModal={this.hideVerifyPhoneOpt}
						phoneNumber={this.state.forgotPasswordWithPhoneNumber}
						action={otpAction.TOA_RECOVER_PASSWORD}
						onVerifyPhoneOptSuccess={this.onVerifyPhoneOptSuccess}
						onBreakVerifyPhoneOtp={this.showVerifyPhoneOptBreak}
					/>
				)}
				{this.state.showVerifyLoginPhoneOpt && (
					<VerifyPhoneOpt
						show={this.state.showVerifyLoginPhoneOpt}
						hideModal={this.hideVerifyLoginPhoneOpt}
						phoneNumber={this.state.forgotPasswordWithPhoneNumber}
						pwd={this.state.ip_password}
						action={otpAction.TOA_VERIFY_LOGIN}
						onVerifyPhoneOptSuccess={this.onVerifyPhoneOptSuccess}
						onBreakVerifyPhoneOtp={this.showVerifyPhoneOptBreak}
						getLoggedProfile={this.props.getLoggedProfile}
					/>
				)}
				{this.state.showVerifyPhoneOptBreak && (
					<VerifyPhoneOptBreak show={this.state.showVerifyPhoneOptBreak} hideModal={this.hideVerifyPhoneOptBreak} />
				)}
				<ResetPwForm
					show={this.state.showResetPwForm}
					hideModal={this.hideResetPwForm}
					hideForgotPasswordForm={this.hideForgotPasswordForm}
					showLoginModal={this.props.showModal}
					otpData={this.state.otpData}
				/>
				{this.state.isShowVerifyEmail && (
					<ResetPwByEmail
						show={this.state.isShowVerifyEmail}
						hideModal={this.hideVerifyEmail}
						showLoginModal={this.props.showModal}
						email={this.state.emailForReset}
					/>
				)}
			</>
		);
	}
}

export default withRouter(Login);
